import BaseContainer from "@base/container/BaseContainer";
import ParallaxContainer from "./ParallaxContainer";
import * as PIXI from "pixi.js";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";
import {Signals} from "@/Imports";
import gsap from 'gsap';
import Facade from "../Facade";

export default class GameBackgroundContainer extends BaseContainer {

  constructor(data = null) {
    super(data)

    this.init()

    Signals.makeBets.add(this.onMakeBets, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
  }

  init() {
    const moon = new PIXI.Sprite(PIXI.Texture.from('parallax/moon'))
    moon.name = 'moon'
    moon.scale.set(0.6)
    moon.position.set(600, 250)

    this.addChild(moon)
    const moonClouds = new PIXI.Sprite(PIXI.Texture.from('parallax/moonClouds'))
    moonClouds.name = 'moon clouds'
    moonClouds.position.set(0, 0)
    this.addChild(moonClouds)

    this.bg = new ParallaxContainer()
    this.addChild(this.bg)


    this.face = new SpineAnimation('evilFace')
    this.face.scale.set(0.5)
    this.face.visible = false
    this.addChild(this.face)

    this.pursuitFace = new SpineAnimation('boss')
    this.pursuitFace.position.set(-100, 200);
    this.pursuitFace.scale.set(-1.5, 1.5);
    this.addChild(this.pursuitFace)

  }

  onMakeBets() {
    this.bg.slow();
    this.showBossFace();
  }

  onRoundStart() {
    this.bg.fast();
    this.hideBossFace();
    this.delay = 0;
    gsap.to(this, 10, {delay: 10, onComplete: () => this.moveCloudFace()})
  }

  onRoundEnd() {
    gsap.killTweensOf(this);
    gsap.killTweensOf(this.face)
    gsap.killTweensOf(this.pursuitFace)

    this.face.visible = false
    this.face.stop();
  }

  moveCloudFace() {
    const repeat = (immediately) => {
      Facade.soundManager.play('evil_cloud_face');
      const begin = 'in';
      const loop = 'loop';
      const end = 'out';
      const animations = [begin, end];
      this.face.start(animations, animations.map(v => !v))
      this.face.position.set(700, 80)
      this.face.visible = true
      gsap.to(this.face, immediately ? 0.5 : 30, {x: Math.random() * 310, onComplete: repeat})
    }

    repeat(true)
  }

  showBossFace() {
    this.pursuitFace.start(['appears', 'idle2', 'idle'], [false, false, true]);
    gsap.to(this.pursuitFace, 2, {x: 290, y: 200});
  }

  hideBossFace() {
    gsap.to(this.pursuitFace, 2, {
      x: -100, onComplete: () => {
        this.pursuitFace.stop();
      }
    });
  }
}
